// Wait to the document to initialize
$(document).ready(function() {
  // Create hash map of icons (we instantiate the icons to begin with, and interact with them later)
  var icons = {};

  // Iterate through each icon (and diagram) that should be animated
  $('.icon--animation, .diagram--animation').each(function() {
    // Lets create a neat reference to the current icon element
    var $icon = $(this);

    // If the icon does not have a element id
    if (!$icon.attr('id')) {
      // Lets give it one, as Vivus.js requires this
      $icon.attr('id', 'icon-id-'+ _.uniqueId());
    }

    // Get the id of the element
    var id = $icon.attr('id');
    // Get svg path (background-image) of the element
    var file = $icon.css('background-image');

    // Lets hide the background-image, as we'll otherwise
    // draw it twice, and display the icon (that has been hidden until now)
    $icon.css({
      'background-image': 'none',
      'display': 'block'
    });

    // Remove a bit of mess from the file url
    file = file.replace('url(', '').replace(')', '').replace(/\"/gi, '');

    // Show icon
    $icon.removeClass('hide');

    // Initialize the Vivus.js instance of the icon
    // We set the start to manual, so we can later
    // execute the drawing, when the icon is within
    // the actual viewport.
    icons[id] = new Vivus(id, { file: file, start: 'manual' }, function(obj) {
      // When the animation has finished, lets add a finished class to it
      // This way, we can provoke further animation using css (e.g. solid fill animations)
      obj.el.classList.add('finished');
    });
  });

  // Method for actually drawing icons currently
  // present in the (slightly modified) viewport
  var iconize = function() {
    // What is the upper limit of the viewport (we add the height of the navigation)
    var viewportTop = $(window).scrollTop() + 145;
    // What is the lower limit of the viewport (we substract the height of the navigation, plus some)
    var viewportBottom = $(window).height() + viewportTop - 145 - 50;

    // Iterate through each icon
    $('.icon--animation, .diagram--animation').each(function() {
      // Make a neat reference to the current icon
      var $icon = $(this);

      // Check if the icon has been animated before, and whether it is within our defined viewport
      if (!$icon.data('animated') && viewportTop < $icon.offset().top && $icon.offset().top < viewportBottom) {
        // Sometimes Vivus.js do not behave, but the animations
        // will still succeed. We ignore bad behaviour.
        try {
          // If the icon is within the view port, then
          // play the animation
          icons[$icon.attr('id')].play();
          // Mark the icon as animated, so it does not repeatedly
          // animate when being in the viewport
          $icon.data('animated', true);
        } catch (e) { }
      }
    });
  };

  // When the user scrolls, keep drawing the icons
  // that might be in the current viewport
  // (Debouncing the event to save a bit of resources)
  $(window).on('scroll', _.throttle(iconize, 100));

  // Initialize iconization with a small timeout,
  // so that Vivus.js get a change to think
  setTimeout(iconize, 100);

  setTimeout(function(){
    $(window).triggerHandler('scroll');
  }, 500);
});


/*****************
 ** WEBPACK FOOTER
 ** ./source/js/icon.js
 ** module id = 3
 ** module chunks = 0
 **/